var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97D23"
    },
    d: "M44.57,93.84c0,0,2.67,7.18,1.13,9.71c-1.55,2.53-7.74,2.04-9.64,3.24  c-1.36,0.86-1.34,3.24-0.49,4.22c0.84,0.99,13.09,0.14,15.49-4.5S50.2,92.99,50.2,92.99L44.57,93.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97D23"
    },
    d: "M64.13,92.99l-5.21,1.13c0,0,2.25,9.43,0.42,12.53c-1.83,3.1-8.39,6.41-9.57,9.01  c-1.06,2.32,1.55,4.22,5.63,1.69s8.7-6.31,9.57-8.17C67.09,104.68,64.13,92.99,64.13,92.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36B4E1"
    },
    d: "M28.52,21.9C17.44,24.39,8.81,33.73,12.05,47.94c1.92,8.43,3.1,11.4,3.8,15.2  c1.48,7.99,1.08,11.5,4.46,18.82c3.59,7.79,16.8,17.79,33.27,15.39s23.09-4.65,23.09-4.65l5.91-5.21l5.63-1.41l0.84-4.08  c0,0,4.21-0.19,5.07-1.55c1.36-2.16,0.56-3.94-1.83-4.79c-2.39-0.84-3.8-1.55-3.8-1.55s23.23-15.35,26.04-17.03s7.18-4.58,7.39-5.63  c0.53-2.67-6.69-8.59-16.12-11.4c-9.43-2.82-17.53-3.59-18.86-2.53c-1.77,1.39-9.57,16.05-14.78,15.35  c-6.76-0.92-11.4-7.25-12.67-10.84C58.05,37.96,49.4,17.21,28.52,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97D23"
    },
    d: "M14.3,43.86c-1.69-0.28-6.01,4.32-6.85,5.44s-2.17,2.73-1.69,3.94c0.75,1.88,4.6,1.98,6.85,2.16  c2.35,0.19,6.85,0.56,7.6-0.84c0.75-1.41-0.84-4.97-2.16-7.13C16.83,45.42,16.06,44.16,14.3,43.86z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9928 -0.1196 0.1196 0.9928 -4.9855 4.1639)",
    style: {
      fill: "#2A2D2F"
    },
    cx: 32.19,
    cy: 43.61,
    rx: 4.02,
    ry: 4.36
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#026AA8"
    },
    d: "M45.41,73.71c-1.95,0.71,0.61,7.6,3.24,10.7c2.77,3.26,9.47,10.58,19.71,11.54  c6.95,0.66,10.04-1.31,11.68-3.1c1.22-1.33,2.53-2.87,3.43-3.57c1.31-1.03,2.63-0.14,4.88-1.78c1.62-1.18,1.97-3.14,2.82-3.85  c0.84-0.7,2.27-0.54,3-1.22c1.31-1.22,1.13-4.79,0.19-4.97s-1.03,2.53-1.97,2.91s-2.19,0.14-3.94,1.13  c-1.5,0.84-1.03,2.53-2.06,3.28s-2.91-0.28-5.44,1.13c-1.37,0.76-2.53,4.41-6.48,5.26c-4.9,1.05-12.25-2.52-15.77-5.07  C50.53,80.18,48.74,72.49,45.41,73.71z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.9def6fb7542aafbe9e23fa4e9de08777.svg";
export { ForwardRef as ReactComponent };